import {io} from 'socket.io-client';
import { baseURL } from '.';


const socket = io(baseURL);
const token = localStorage.getItem('token');



socket.emit('connection', {
  userId: 'test',
});

export default socket;
